<template>
    <div id="editor">
        <editorTop></editorTop>
        <div class="main" :style="{ height: mianH + 'px' }">
            <editorLeft></editorLeft>
            <editorRight></editorRight>
        </div>
        <vipPopup></vipPopup>
    </div>
</template>

<script>
import editorTop from '@/components/hottc/editor_top.vue' //编辑顶部
import editorLeft from '@/components/hottc/editor_left.vue' //编辑左边
import editorRight from '@/components/hottc/editor_right.vue' //编辑右边
import vipPopup from '@/components/vip_popup.vue' //vip页面
export default {
    components: {
        editorTop,editorRight,editorLeft,vipPopup
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 80;
        }
    }
}
</script>

<style>
#editor {
    width: 100%;
    min-width: 1500px;
    height: 100vh;
    background-color: #F8F9FA;
}

#editor .main {
    width: 100%;
    min-width: 1500px;
    margin-top: 13px;
    display: flex;
}
</style>